import { HostBinding, Component, OnInit, Injector } from '@angular/core';
import { EventsComponent } from '../events/events.component';

@Component({
	selector: 'Checkbox',
	host: { '[class]': 'myCustomClass' },
	template: `
		<label
			#inputLabel
			role="checkbox"
			[attr.id]="labelId"
			[attr.aria-checked]="inputLabel.classList.contains('checked')"
			[tabindex]="control.disabled ? -1 : 0"
			[ngClass]="{ disabled: control.disabled }"
			(keydown)="toggle($event)"
		>
			<input
				gtm-handler
				[attr.gtm]="control.name"
				events="change"
				handlerType="checkbox"
				[label]="control.name"
				action="BoxCheck"
				[value]="value"
				type="checkbox"
				[attr.id]="control.name.split('PolicyData.').join('')"
				[(ngModel)]="value"
				(change)="onChange(value)"
				class="custom-checkbox-input"
				[disabled]="control.disabled"
			/>

			<span class="custom-input"></span>

			<div class="custom-checkbox-title" [innerHtml]="control.attributes.title"></div>
		</label>
	`,
	styleUrls: ['./check-box.component.scss'],
})
export class CheckBoxComponent extends EventsComponent implements OnInit {
	@HostBinding('attr.name')
	name = this.control ? this.control.name : '';
	labelId: string;

	constructor(injector: Injector) {
		super(injector);
	}
	async ngOnInit() {
		this.gaLabel = this.getGaLabel(this.control);
		if (this.value) {
			this.reportPrefill();
			this.elementRef.nativeElement.querySelectorAll('label span')[0].classList.add('checked');
			this.elementRef.nativeElement.querySelectorAll('label')[0].classList.add('checked');
		}
		this.labelId = this.name + '_label';
	}

	toggle(event) {
		if (event.keyCode === 13 || event.keyCode === 32) {
			this.value = !this.value;
			this.onChange(this.value);

			event.preventDefault();
			event.stopPropagation();
			event.stopImmediatePropagation();
		}
	}

	onChange(value) {
		this.splunkAnalyticsService.publish('CheckboxChange', this.control.attributes.title, value);
		this.setAnswer(value);
		this.reportEditedPrefillValue();
		this.elementRef.nativeElement.querySelectorAll('label span')[0].classList.toggle('checked');
		this.elementRef.nativeElement.querySelectorAll('label')[0].classList.toggle('checked');
	}
}
